import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarCollapseComponent } from '../../organisms/sidebar-collapse/sidebar-collapse.component';
import { LayoutService } from '@services/ui-services/layout.service';

@Component({
  selector: 'app-overlay-layout',
  templateUrl: './overlay-layout.component.html',
  styleUrls: ['./overlay-layout.component.scss'],
  imports: [CommonModule, SidebarCollapseComponent],
})
export class OverlayLayoutComponent {
  //TODO: will remove from here when refine all overlay
  constructor(private LayoutService: LayoutService) {}

  closeOverlay() {
    setTimeout(() => {
      this.LayoutService.toggleLayoutOverlay(false);
      this.onClose.emit();
    });
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeOverlay();
    }
  }

  @Input()
  action: boolean = false;

  @Input()
  collapseTitle: string = 'Collapse sidebar';

  @Input()
  overlay_footer: boolean = true;

  @Input() bigFooter: boolean = false;
  @Input() smallFooter: boolean = false;

  @Input()
  added: boolean = false;

  @Input()
  lightBackground: boolean = false;

  @Input()
  header_type = 'open';

  @Output()
  onClose = new EventEmitter();
}
